"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Eye = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Eye = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M62.6,33.6C61.1,30,59,26.7,56.2,24c-2.7-2.8-5.9-5-9.4-6.6c-9.4-4-20.1-4-29.5,0\r C12.4,19.6,8.1,23.1,5,27.5c-1.4,1.9-2.6,4-3.4,6.2c-0.1,0.3-0.1,0.7,0,1c1.4,3.6,3.5,6.9,6.2,9.7c2.7,2.8,5.9,5,9.4,6.6\r c9.6,4,20.3,4,29.9,0c4.9-2.2,9.2-5.7,12.3-10.1c1.4-1.9,2.5-4,3.3-6.2C62.7,34.3,62.7,34,62.6,33.6z M53.9,42.3\r c-2.4,2.4-5.2,4.4-8.4,5.7c-8.7,3.5-18.4,3.5-27.1-0.1c-4.4-2-8.2-5.1-11-9c-0.9-1.2-1.6-2.5-2.2-3.8c-0.2-0.4-0.3-0.7-0.4-1\r c2.8-6.2,7.8-11.1,14-13.9c8.5-3.5,18.1-3.5,26.6,0.1c4.4,2,8.2,5.1,11.1,9c0.9,1.2,1.7,2.5,2.3,3.8c0.2,0.4,0.3,0.7,0.5,1\r C58,37.2,56.2,40,53.9,42.3z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M32.1,23.4c-5.9,0-10.7,4.8-10.7,10.7c0,5.9,4.8,10.7,10.7,10.7c5.9,0,10.7-4.8,10.7-10.7\r c0,0,0,0,0,0C42.8,28.2,38,23.4,32.1,23.4C32.1,23.4,32.1,23.4,32.1,23.4z M32.1,41.7c-4.1,0-7.5-3.4-7.5-7.5c0-4.1,3.4-7.5,7.5-7.5\r c4.1,0,7.5,3.4,7.5,7.5c0,2-0.8,3.9-2.2,5.3C36,40.9,34,41.7,32.1,41.7L32.1,41.7z"
    })]
  });
};
exports.Eye = Eye;